import { ExpandMoreRounded as ExpandIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

export interface IExpandButtonProps {
  isExpanded: boolean;
  onToggle: () => void;
  dataTestId?: string;
  disabled?: boolean;
}

export const ExpandButton = (props: IExpandButtonProps) => {
  const { isExpanded, onToggle, dataTestId = 'ToggleCollapseButton', disabled = false } = props;

  return (
    <IconButton
      data-testid={dataTestId}
      disabled={disabled}
      size="small"
      sx={{ p: 0 }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }}
    >
      <ExpandIcon
        sx={{
          transform: isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
          transition: 'transform 150ms ease-in-out',
          width: 20,
          height: 20,
        }}
        color={isExpanded ? 'primary' : 'secondary'}
      />
    </IconButton>
  );
};
